/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const confirmTelegramOidcSwitchResponseSchema = z.object({
  success: z.boolean(),
  switched: z.boolean(),
});

export type IConfirmTelegramOidcSwitchResponse = z.infer<
  typeof confirmTelegramOidcSwitchResponseSchema
>;
